module.exports = __webpack_public_path__ + "packs/media/images/crowdfunding/falesia6_thumb-a75a58bb12b7b6498c40b91624cf4a52.jpg";